module.exports = __webpack_public_path__ + "img/faq-illustrations.5e68476c.svg";